import { extensions } from 'mime-types';

/**
 * Returns file extensions WITHOUT a leading dot. Mimes that do not match a
 * specific extension are filtered out.
 *
 * Example: "image/jpg, image/png, image/*" -> ["jpg", "png"]
 */
export const parseMimesToExtensions = (mimes: string) => {
    return mimes
        .split(',').map(m => m.trim())
        .flatMap(a => extensions[a])
        .filter(e => e);
};